import React, { useRef } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { useDrag, useDrop } from "react-dnd";

import {
  removeQuestion,
  setEditQuestion,
  rearrangeItems,
  resetIds,
  setWarning
} from '../../../../../../../_actions/questionnaire.actions';

import {
  removeQuestion as removeDocumentQuestion,
  decrementLinkId,
  incrementLinkId
} from '../../../../../../../_actions/document-builder.actions';

const Card = (props) => {
  const { index, question, editQuestion, dispatch } = props;

  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: 'QuestionCard',
    drop: (item, monitor) => {
      if (monitor.didDrop()) {
        return;
      }

      dispatch(resetIds());
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }

      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current?.getBoundingClientRect();

      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      dispatch(rearrangeItems(dragIndex, hoverIndex));

      item.index = hoverIndex;
    }
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type: 'QuestionCard', id: question.linkId, index, originalIndex: index },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    }),
    end: (dropResult, monitor) => {
      const didDrop = monitor.didDrop();
      const movedItem = monitor.getItem();

      const to = movedItem.index;
      const from = movedItem.originalIndex;

      if (!didDrop) {
        dispatch(rearrangeItems(to, from));
      } else {
        dispatch(setWarning());

        if (to < from) {
          dispatch(incrementLinkId(to, from))
        } else {
          dispatch(decrementLinkId(to, from));
        }
      }
    }
  });

  const cssStyle = classNames('card', 'mb-2', {
    'border-success': question.linkId === editQuestion,
    'border-light': question.linkId !== editQuestion
  });

  drag(drop(ref));

  return (
    <div
      ref={ref}
      style={{
        cursor: 'move',
        opacity: isDragging ? 0 : 1
      }}
      className={cssStyle}>
      <div className="card-body">
        {props.children}
      </div>

      <div className="card-footer">
        <a href="#!" onClick={(e) => { e.preventDefault(); dispatch(setEditQuestion(question)) }} className="card-link text-muted text-decoration-none">
          <small>Properties</small>
        </a>

        <a href="#!" onClick={(e) => {
          e.preventDefault();

          dispatch(removeQuestion(question));
          dispatch(removeDocumentQuestion(question));

        }} className="card-link text-muted text-decoration-none">
          <small>Remove</small>
        </a>
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    editQuestion: state.questionnaire.editQuestion
  }
}

export default connect(mapStateToProps)(Card)